// @ts-nocheck
import { Toast } from "antd-mobile";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getText } from "../../../../utils/util";
// 导入新的CSS文件
import "./tailwind.css";

export default function CenterPage({ list }) {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const statusStr = [
    translate(getText("待支付")),
    translate(getText("审核通过")),
    translate(getText("审核拒绝")),
    translate(getText("分配卡号")),
    translate(getText("取消订单")),
    translate(getText("审核中")),
  ];
  
  // 定义状态对应的样式类
  const statusClasses = {
    1: "text-warning", // 待支付 - 黄色警告色
    2: "text-success", // 审核通过 - 绿色成功色
    3: "text-danger",  // 审核拒绝 - 红色危险色
    4: "text-info",    // 分配卡号 - 蓝色信息色
    5: "text-neutral-400", // 取消订单 - 灰色
    6: "text-primary pulse", // 审核中 - 主色调，加上脉动效果
  };
  
  const getArray = () => {
    const nodes = [];
    for (const item of list) {
      if (item.img && item.status == 1) {
        item.status = 6;
      }
      nodes.push(
        <div
          key={item?.orderNo}
          className="relative p-4 border-b border-neutral-700 transition-colors hover:bg-neutral-800/50 cursor-pointer record-item-enter"
          style={{animationDelay: `${nodes.length * 0.05}s`}}
          onClick={() => {
            if (item?.status == 1) {
              navigate(`/c2cckimage/${item?.orderNo}`);
            } else if (
              item?.status == 2 ||
              item?.status == 3 ||
              item?.status == 4 ||
              item?.status == 5 ||
              item?.status == 6
            ) {
              navigate(`/c2cckinfo/${item?.orderNo}`);
            }
          }}
        >
          <div className="flex justify-between items-center mb-2">
            <span className="text-lg font-medium text-neutral-100">{item?.czNum}</span>
            <div className={`font-medium px-3 py-1 rounded-full status-badge ${statusClasses[item?.status] || 'text-neutral-300'}`}>
              {statusStr[item?.status - 1]}
            </div>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm text-neutral-400">{item?.createTime}</span>
            <div className="text-sm text-neutral-400">{item?.orderNo}</div>
          </div>
        </div>
      );
    }
    return nodes;
  };
  
  return (
    <div className="divide-y divide-neutral-700">
      {list.length > 0 ? (
        <div>{getArray()}</div>
      ) : (
        <div className="flex flex-col items-center justify-center py-16">
          <div className="text-neutral-500 mb-2">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <span className="text-neutral-400">暂无数据</span>
        </div>
      )}
      {list.length > 0 && (
        <div className="text-neutral-400 text-center py-4 text-sm">
          {translate(getText("没有更多数据了"))}
        </div>
      )}
    </div>
  );
}
